import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getSandreList } from '../../../utils/StoreUtils'
import StationMapDashboardPanel from '../../../station/components/dashboard/component/map/StationMapDashboardPanel'
import Input from '../../../components/forms/Input'
import DatePicker from '../../../components/forms/DatePicker'
import NumberField from '../../../components/forms/NumberField'
import Select from '../../../components/forms/Select'
import Textarea from '../../../components/forms/Textarea'
import Checkbox from '../../../components/forms/Checkbox'
import { SANDRE } from '../../../referencial/constants/ReferencialConstants'
import { hasValue } from '../../../utils/NumberUtil'
import LastEventPanel from '../../../station/components/event/LastEventPanel'
import ContactCard from '../../../referencial/components/contact/components/ContactCard'
import StationUpdatePanel from '../../../station/components/update/StationUpdatePanel'
import { some } from 'lodash'
import { getControlColor } from '../../../utils/InstallationUtils'
import { getColorCircleElement, getRGBColor } from '../../../utils/ColorUtil'
import InstallationAction from '../../actions/InstallationAction'
import LinkedStationsPanel from '../../../station/components/associatedStation/LinkedStationsPanel'
import MaterielAssigned from '../../../station/components/materiel/MaterielAssigned'

import InstallationInfosDashboard from '../installations/components/InstallationInfosDashboard'
import { H_MAT_MODULE } from '../../../account/constants/AccessRulesConstants'
import HabilitationRequired from '../../../utils/components/HabilitationRequired'
import { Card, CardContent, Grid2 } from '@mui/material'
import InstallationChartPanel from 'installation/components/installations/components/InstallationChartPanel'
import useSandreList from 'utils/customHook/useSandreList'
import { INSTALLATION_TYPE } from 'installation/constants/InstallationConstants'
import { InstallationActionConstant } from 'installation/reducers/InstallationReducer'
import { CardTitle } from 'components/card/NewCard'

const FlowObstructionDashboardPanel = ({
    stationType = '',
}) => {
    const {
        installation,
        cities,
        sandreCodes,
        users,
        status,
        installationEvents,
        flowObstruction,
    } = useSelector(store => ({
        installation: store.InstallationReducer.installation,
        cities: store.CityReducer.cities,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        users: store.UserReducer.users,
        status: store.QualityReducer.status,
        installationEvents: store.InstallationReducer.installationEvents,
        flowObstruction: store.InstallationReducer.flowObstruction,
    }), shallowEqual)

    const flowObstructionUsages = useSandreList(SANDRE.FLOW_OBSTRUCTION_USAGE)
    const flowObstructionStatut = useSandreList(SANDRE.FLOW_OBSTRUCTION_STATUT)
    const flowObstructionHeight = useSandreList(SANDRE.FLOW_OBSTRUCTION_HAUTEUR)
    const flowObstructionType = useSandreList(SANDRE.FLOW_OBSTRUCTION_TYPE)
    const flowObstructionValidite = useSandreList(SANDRE.FLOW_OBSTRUCTION_VALIDITE)
    const flowObstructionDispositif = useSandreList(SANDRE.FLOW_OBSTRUCTION_DISPOSITIF)

    const dispatch = useDispatch()

    useEffect(() => {
        if (installation.installationType === INSTALLATION_TYPE.FLOW_OBSTRUCTION) {
            dispatch(InstallationAction.fetchFlowObstruction(installation.id))
        }
        return () => {
            dispatch(InstallationActionConstant.FLOW_OBSTRUCTION({}))
        }
    }, [])

    const getOriginStatusColor = () => {
        if (hasValue(installation.status)) {
            const color = getControlColor(installation.status)
            return getColorCircleElement(getRGBColor(color), true)
        }
        return null
    }

    const showFlowObstruction = hasValue(flowObstruction.validityDate) || hasValue(flowObstruction.usageCode) || hasValue(flowObstruction.statusCode) || hasValue(flowObstruction.fallHeightCode) || hasValue(flowObstruction.typeCode) || hasValue(flowObstruction.validityCode) || hasValue(flowObstruction.flowDeviceCode)

    const readMode = { readMode: true, editMode: false, hideNull: true }

    return (
        <Grid2 container sx={{ padding: '10px 0 60px 0' }} spacing={1} alignItems={'flex-start'}>
            <Grid2 container size={9}>
                <Grid2 size={12}>
                    <InstallationInfosDashboard />
                </Grid2>
                { some(['exploitationCode', 'comments'], key => hasValue(installation[key])) && (
                    <Grid2 size={12}>
                        <Card>
                            <CardTitle title={i18n.characteristics} />
                            <CardContent>
                                <Grid2 container size={12}>
                                    <Grid2 size={6}>
                                        <Checkbox
                                            checked={hasValue(installation.exploitationCode) ? installation.exploitationCode == 1 : null}
                                            label={i18n.exploitation}
                                            disabled {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={6}>
                                        <Textarea
                                            value={installation.comments}
                                            title={i18n.comment}
                                            {...readMode}
                                        />
                                    </Grid2>
                                </Grid2>
                            </CardContent>
                        </Card>
                    </Grid2>
                )}
                { showFlowObstruction && (
                    <Grid2 size={12}>
                        <Card>
                            <CardTitle title={i18n.flowObstruction}/>
                            <CardContent>
                                <Grid2 container size={12}>
                                    <Grid2 size={6}>
                                        <DatePicker
                                            value={flowObstruction.validityDate}
                                            title={i18n.validityDate}
                                            {...readMode}
                                        />
                                        <Select
                                            label={i18n.usage}
                                            options={flowObstructionUsages}
                                            value={flowObstruction.usageCode}
                                            {...readMode}
                                        />
                                        <Select
                                            label={i18n.status}
                                            options={flowObstructionStatut}
                                            value={flowObstruction.statusCode}
                                            {...readMode}
                                        />
                                        <Select
                                            label={i18n.fallHeight}
                                            options={flowObstructionHeight}
                                            value={flowObstruction.fallHeightCode}
                                            {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={6}>
                                        <Select
                                            label={i18n.type}
                                            options={flowObstructionType}
                                            value={flowObstruction.typeCode}
                                            {...readMode}
                                        />
                                        <Select
                                            label={i18n.validity}
                                            options={flowObstructionValidite}
                                            value={flowObstruction.validityCode}
                                            {...readMode}
                                        />
                                        <Select
                                            label={i18n.flowDevice}
                                            options={flowObstructionDispositif}
                                            value={flowObstruction.flowDeviceCode}
                                            {...readMode}
                                        />
                                    </Grid2>
                                </Grid2>
                            </CardContent>
                        </Card>
                    </Grid2>
                )}
                <Grid2 size={12}>
                    <InstallationChartPanel stationId={installation.id} stationCode={installation.code} />
                </Grid2>
            </Grid2>
            <Grid2 container size={3}>
                <Grid2 container sx={{ marginRight: 1 }}>
                    <Grid2 size={12}>
                        <StationUpdatePanel station={installation}/>
                    </Grid2>
                    { some(['dataOrigin', 'closeComment', 'status', 'statusDate', 'deliberationDate', 'confidential'], key => hasValue(installation[key])) && (
                        <Grid2 size={12}>
                            <Card>
                                <CardContent>
                                    {hasValue(installation.jobExecutionId) && (
                                        <h6 className='valign-wrapper'>
                                            <i className='material-icons rem-3-size padding-right-1'>wifi</i>
                                            {i18n.automaticUpdate}
                                        </h6>
                                    )}
                                    <Grid2 size={12} sx={{ marginTop: 1 }}>
                                        <Input
                                            title={i18n.dataOrigin}
                                            value={installation.dataOrigin}
                                            {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <Select
                                            label={[getOriginStatusColor(), i18n.status]}
                                            value={installation.status}
                                            options={status}
                                            {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <DatePicker
                                            value={installation.statusDate}
                                            id='statusDate'
                                            title={i18n.controlDoneAt}
                                            {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <Select
                                            label={i18n.controlDoneBy}
                                            value={installation.statusLogin}
                                            options={users.map(u => ({ code: u.login, name: u.name || u.login }))}
                                            {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <DatePicker
                                            value={installation.endDate}
                                            id='deliberationDate'
                                            title={i18n.deliberationDate}
                                            {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <Input
                                            value={installation.closeComment}
                                            title={i18n.become}
                                            {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <Checkbox
                                            label={i18n.confidential}
                                            {...readMode}
                                            checked={hasValue(installation.confidential) ? installation.confidential == '1' : null}
                                        />
                                    </Grid2>
                                </CardContent>
                            </Card>
                        </Grid2>
                    )}
                    <ContactCard
                        title={i18n.contact}
                        contactCode={installation.ownerCode}
                        {...readMode}
                    />
                    {some(['address', 'x', 'y', 'altitude', 'parcel', 'section', 'ignMap', 'geologicalMap'], key => hasValue(installation[key])) && (
                        <Grid2 size={12}>
                            <Card>
                                <CardContent>
                                    <Grid2 size={12}>
                                        <Input
                                            title={i18n.address}
                                            value={installation.address}
                                            {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <Select
                                            value={installation.townCode}
                                            label={i18n.city}
                                            options={cities}
                                            keyValue='id'
                                            displayWithCode {...readMode}
                                        />
                                    </Grid2>
                                    <Grid2 container size={12}>
                                        <Grid2 size={6}>
                                            <NumberField
                                                title='X'
                                                value={installation.x}
                                                floatValue
                                                {...readMode}
                                            />
                                        </Grid2>
                                        <Grid2 size={6}>
                                            <NumberField
                                                title='Y'
                                                value={installation.y}
                                                floatValue
                                                {...readMode}
                                            />
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 container size={12}>
                                        <Grid2 size={6}>
                                            <NumberField
                                                title='Z'
                                                value={installation.altitude}
                                                floatValue
                                                {...readMode}
                                            />
                                        </Grid2>
                                        <Grid2 size={6}>
                                            <Select
                                                label={i18n.projection}
                                                value={installation.projection}
                                                options={getSandreList(sandreCodes, SANDRE.PROJECTION)}
                                                {...readMode}
                                            />
                                        </Grid2>
                                    </Grid2>
                                </CardContent>
                            </Card>
                        </Grid2>
                    )}
                    <HabilitationRequired habilitation={H_MAT_MODULE}>
                        <MaterielAssigned
                            stationId={installation.id}
                            type={stationType}
                        />
                    </HabilitationRequired>
                    <Grid2 size={12}>
                        <LastEventPanel
                            id={installation.id}
                            events={installationEvents}
                            stationId={installation.id}
                            stationType='installation'
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <StationMapDashboardPanel
                            noMarkerTooltip
                            station={installation}
                            type={'installation'}
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <LinkedStationsPanel
                            dashboardMode
                            checkable
                            station={installation}
                            withColors
                            hideTitle
                        />
                    </Grid2>
                </Grid2>
            </Grid2>
        </Grid2>
    )
}

FlowObstructionDashboardPanel.propTypes = {
    stationType: PropTypes.string,
    setDataLoaded: PropTypes.func,
}

export default FlowObstructionDashboardPanel